<template>
  <aside :class="{ sidebar: true }" id="sidebar">
    <logo-router>
      <logo :custom-logo="customLogo" />
    </logo-router>
    <div class="sidebar__items">
      <side-nav-sections :user="user" />
      <bottom-logo v-if="customLogo.hasOwnProperty('file_url')" />
    </div>
  </aside>
</template>

<script>
import Logo from "Public/components/SideNav/Logo/Logo";
import SideNavSections from "Public/components/SideNav/SideNavSections/SideNavSections";
import {
  AUTH_USER_GET,
  AUTH_USER_STATE_UPDATE,
} from "Public/store/modules/auth";
import { mapGetters } from "vuex";
import BottomLogo from "Public/components/SideNav/BottomLogo";
import { getProviderLogo } from "Adapters/ApiAdapter/user";
import LogoRouter from "Public/components/SideNav/Logo/LogoRouter";
export default {
  name: "SideNav",
  components: { LogoRouter, BottomLogo, SideNavSections, Logo },
  computed: { ...mapGetters({ user: AUTH_USER_GET }) },
  data() {
    return {
      customLogo: {},
    };
  },
  methods: {
    updateCustomLogo() {
      if (this.user && this.user.id) {
        getProviderLogo().then((response) => {
          this.customLogo = Object.assign({}, response.data);
        });
      }
    },
  },
  mounted() {
    this.updateCustomLogo();
  },
  created() {
    this.$root.$on("refreshLogo", this.updateCustomLogo);
  },
  beforeDestroy() {
    this.$root.$off("refreshLogo", this.updateCustomLogo);
  },
};
</script>

<style scoped>
.sidebar__items {
  height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
</style>
